// mui
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

// components
import { cancelLogin, confirmLogin } from '..';

// client-shared
import { storage } from '@goldblack/client-storage';

// Asks a guest to log in after they tried an action (follow, like, comment, ...).
function LoginRequiredDialog() {
    const open = storage.transience.getValue('internal.loginPrompt');
    return (
        <Dialog
            open={!!open}
            onClose={cancelLogin}
            slotProps={{
                paper: { elevation: 0, variant: 'outlined', sx: { minWidth: 'min(300px, calc(100vw - 64px))' } },
            }}>
            <DialogTitle variant='m_dialog_title'>Log in required</DialogTitle>
            <DialogContent>
                <DialogContentText variant='m_dialog_content_text'>Log in to continue.</DialogContentText>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center' }}>
                <Button variant='outlined' onClick={cancelLogin}>
                    Cancel
                </Button>
                <Button variant='contained' onClick={confirmLogin}>
                    Log in
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export { LoginRequiredDialog };
